import { IField } from 'app/services/api5-service/api.interface';

import { filterNotDefinedItems } from 'utils/filter-not-defined-items';

import {
  BannerControl,
  getTypeControlForBanner,
  isBannerControl,
} from './get-typed-control-for-banner';
import {
  getTypeControlForTextData,
  TextDataControl,
} from './get-typed-control-for-textdata';
import {
  TotalSumControl,
  getTypeControlForTotalSum,
  isTotalSumControl,
} from './get-typed-control-for-total-sum';

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param field - field metadata
 */
export function getTypeControlsForTextData(
  field: IField,
): (BannerControl | TextDataControl | TotalSumControl)[] {
  const textdataControls = filterNotDefinedItems(
    (field.textdata ? [field.textdata[0]] : []).map(control => {
      if (isBannerControl(control)) {
        return getTypeControlForBanner(control);
      }
      if (isTotalSumControl(control)) {
        return getTypeControlForTotalSum(control);
      }

      return getTypeControlForTextData(control);
    }),
  );

  const htmldataControls: TextDataControl[] = filterNotDefinedItems(
    (field.htmldata ? [field.htmldata[0]] : []).map(control =>
      getTypeControlForTextData(control),
    ),
  );

  return [...htmldataControls, ...textdataControls];
}
